export default "__VITE_ASSET__cca860b0__"